import { toast, ToastType, ToastPosition } from 'react-toastify'
import moment from 'moment-timezone'

export let isConnected = true

export const trimObj = (obj: any) => {
  if ( obj === null || (!Array.isArray(obj) && typeof obj !== 'object')) { return obj }
  return Object.keys(obj).reduce((acc, key) => {
    acc[key.trim()] = typeof obj[key] === 'string' ? obj[key].trim() : trimObj(obj[key])
    return acc
  }, Array.isArray(obj) ? [] : {})
}

const notify = (message: string, type: string) =>
  toast(message, {
    type: type === 'success' ? ToastType.SUCCESS : ToastType.ERROR,
    position: ToastPosition.TOP_RIGHT
  })

// Correct Map URIs
export const showMessage = (message: string, type?: string) => {
  notify(message, type || 'success')
}
export const showMessageIndefinate = (message: string) => {
  console.log(message)
}

export const showErrorMessage = (error: string | any) => {
  if (typeof error === 'string' || error instanceof String) {
    showMessage(error as string, 'error')
  } else if (error && error.message) {
    showMessage(error.message, 'error')
  } else {
    showMessage('Something went wrong please try again', 'error')
  }
}

export const showAlertDialog = (
  title: string,
  message: string,
  okCallBack: () => void,
  cancelable = false
) => {
  console.log(title, message, okCallBack, cancelable)
}
export const dateFormatter = (date: string|Date) => {
  return date ? moment(date).format('MM/DD/YYYY') : ' '
}
